module.exports = __webpack_public_path__ + "img/1495582152.39c661bc.jpg";